let options = {
  root: null,
  rootMargin: "0px",
  threshold: 0.2,
};

function removeClass(el, className) {
  if (el.classList) el.classList.remove(className);
  else
    el.className = el.className.replace(
      new RegExp("\\b" + className + "\\b", "g"),
      "",
    );
}

function intersect(entries, observer) {
  entries.forEach(entry => {
    if (entry.intersectionRatio > options.threshold) {
      entry.target.style.transform = "translateY(0)";
      entry.target.style.opacity = 1;
      // removeClass(entry.target, "unloaded");
    }
  });
}

let observer = new IntersectionObserver(intersect, options);

document.querySelectorAll(".unloaded").forEach(x => observer.observe(x));

let monthYear = document.querySelector('.milestone__month_year');
let spans = document.querySelectorAll('.milestone div span');
let titles = document.querySelectorAll('.milestone__title');

titles.forEach((x,i)=>{
  w = x.offsetWidth;
  if(i==0){
    let nw = monthYear.offsetWidth + w;
    x.style.width = nw + 'px';
  }else{
    let total = titles[i-1].offsetWidth + x.offsetWidth - 40;
    x.style.width = total + 'px';
  }
});

spans.forEach((x,i)=>{
  let exWidth = monthYear.offsetWidth + x.offsetWidth;
  x.style.width = exWidth + 'px';
});


function onLoad(){
  let el = document.querySelector(".hero__content");
  if(el){
    el.classList.add('loaded');
  }

  let titleContainer = document.querySelectorAll('.milestone__id');
  let max = 0;
  titleContainer.forEach(el=>{
    if(el.offsetWidth > max){
      max = el.offsetWidth + 80;
    }
  });

  let followsHero = document.querySelector('.hero--with-quotation + section');
  if(followsHero){
    followsHero.style.paddingTop = max + 'px';
  }
}

document.body.onload = onLoad();